import styled, { css } from 'styled-components/macro'
import { tint } from 'polished'

export const Wrap = styled.div`
  width: 100%;
  max-height: 40rem;
  display: flex;
  flex-direction: column;
  gap: 2.6rem;
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  border-radius: 0.8rem;
  overflow: hidden;
`

export const Container = styled.div`
  width: 100%;
  max-width: calc(100vw - 3.2rem);
  max-height: 40rem;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => tint(0.96, props.theme.color.text)};
  overflow: auto;
`

export const StyleTable = styled.table`
  position: relative;
  width: 100%;
  font-family: ${(props) => props.theme.font.family.default};
  color: ${(props) => props.theme.color.textSecondary};
  transition: color 0.26s ease, box-shadow 0.26s ease;
`

export const Header = styled.tr<{ isStickyHeader: boolean }>`
  position: relative;
  display: table-row;
  background-color: ${(props) => tint(0.96, props.theme.color.text)};
  /* border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder}; */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0.1rem;
    background-color: ${(props) => props.theme.color.elementBorder};
  }
  ${(props) =>
    props.isStickyHeader &&
    css`
      position: sticky;
      top: 0;
      z-index: ${(props) => props.theme.zIndex.minimal};
    `}
`

export const HeaderCell = styled.th`
  padding: 1.2rem 1rem;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 1.2rem;
  line-height: 1.33;
  letter-spacing: 0.006rem;
  text-align: left;
  text-transform: uppercase;
  color: ${(props) => props.theme.color.textHintSecond};
  &:first-child {
    padding: 1.2rem 1rem 1.2rem 1.6rem;
  }
  &:last-child {
    padding: 1.2rem 1.6rem 1.2rem 1rem;
  }
`

export const RowCell = styled.td`
  padding: 0.9rem 1rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  text-align: left;
  &:first-child {
    padding: 0.9rem 1rem 0.9rem 1.6rem;
  }
  &:last-child {
    padding: 0.9rem 1.6rem 0.9rem 1rem;
  }
`

export const Row = styled.tr`
  position: relative;
`
